import { Button, Modal, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import DiamondWeight from "./diamondWeight";
import DiamondColor from "./diamondColor";
import DiamondShape from "./diamondShape";
import DiamondSaturation from "./diamondSaturation";
import DiamondClarity from "./diamondClarity";
import CharFadeText from "../Animation/CharFadeText";
import { useState } from "react";

const GiaNumber = ({
  loader,
  giainputError,
  handleGIAInput,
  handleSubmit,
  isActive,
  giainputTextError,
  payload,
  handleOnchange,
  setPrintActive,
  printActive,
  inputError,
  setStepScroll,
  steps,
  activeGia,
  setActiveGia,
  handlePrintSubmit,
  printReport,
  setPrintReport,
  giaPayload,
}) => {
  const props = {
    payload,
    handleOnchange,
    inputError,
    setStepScroll,
  };
  const [readRarity , setReadRarity] = useState(false);
  const handleSubmitChange = (event) => {
    event.preventDefault();
  };
  return (
    <div
      className="diamond-weight-wrapper diamond-weight-container gia_input"
      id="diamondWeight"
    >
            {!activeGia &&
            <div className="giaBack">
              <LeftArrowSVg />
            <p
                onClick={() => {
                  setActiveGia(!activeGia);
                }}
              >
                Generate {activeGia ? "Manually" : "By GIA"}
              </p>
              </div>
              }

{printActive &&  <Form onSubmit={handleSubmitChange} className="center-gia-input" >
         
          <Form.Group className={`diamond-weight report_id`} >
            <span>#</span>
            <Form.Control
            className="report_id_input"
              type="text"
              placeholder="Report ID"
              // pattern="/^\d{7,10}$/"
              name="report_id"
              value={printReport?.report_id}
              disabled={printReport?.pdfUrl}

              onChange={(e) => handleGIAInput(e)}
              onWheel={(e) => e.target.blur()}
              autoFocus={true}

            />
            {/* {giainputTextError && (
              <span className="error-text">
                Please check the number you entered
              </span>
            )} */}
          </Form.Group>
          <div className="rarity-process-content rarity-gia-btn">
          
            <Button
            
              className={`${ printReport?.pdfUrl ? "download-report outline-btn" : "processBtn newProcessBtn "}` }
              disabled={(printReport?.report_id?.length !== 12 && printReport?.report_id?.length !== 15) && !printReport?.pdfUrl}
              onClick={() => {
                if (printReport.pdfUrl){
                  window.open(printReport.pdfUrl);
                }else{
                  handlePrintSubmit()
                }
              }}
              type="submit"
            >
              {loader  ? <Spinner animation="border" /> :<div className="print-icon"> { printReport?.pdfUrl ? <>  <span > <PrintIcon/> 
             Print</span>
              </>  :<>
                <span>Search ID</span></>}
  
</div> }

            </Button>
{printReport?.pdfUrl &&<Button
            
            className={`processBtn newProcessBtn mt-4` }
            // disabled={printReport?.report_id?.length !== 13 || printReport?.pdfUrl}
            onClick={() => {
              setPrintReport({
                ...printReport,
                report_id: "",
                pdfUrl: ""
              })
              
            }}
            type="submit"
          >
            {loader  ? <Spinner animation="border" /> :<div className="print-icon"> { <>
              <span>Print Another</span></>}

</div> }

          </Button>}
            <div className="manual_generate generate_report">
              <p
                onClick={() => {
                   setPrintActive(!printActive);
                }}
              >
              <LeftArrow/> {" "}  Generate Report
              </p>
            </div>
          </div>
        </Form>}
              
      {!printActive && (
       activeGia ? (
        <Form onSubmit={handleSubmitChange} className="center-gia-input" >
          <div class="rarity-tab-beta " >
          {/* <span class="beta-top1 tab-beta">[BETA]</span> */}
          <h5>create your rarity report</h5>
          </div>
          <Form.Group
            className={`diamond-weight ${giainputError ? "error-2" : ""}`}
          >
          
        
            <Form.Control
            className=""
              type="number"
              placeholder="GIA Report Number"
              pattern="/^\d{7,10}$/"
              name="number"
              onChange={(e) => handleGIAInput(e)}
              value= {giaPayload?.giaNumber}
           
              onWheel={(e) => e.target.blur()}
              autoFocus={true}
            />
            {giainputTextError  && (
              <span className="error-text">
                Please check the number you entered
              </span>
            )}
          </Form.Group>
          <div className="rarity-process-content rarity-gia-btn">
            <Button
              className="processBtn newProcessBtn generate-btn "
              disabled={giainputError}
              onClick={() => handleSubmit("fromgia")}
              type="submit"
            >
              {loader  ? <Spinner animation="border" /> : <CharFadeText text="Generate" disabled={giainputError} />}
            </Button>
            <div className="manual_generate">
              <div className="generat-ortext">
                <p>OR</p>
              </div>
                 <p
                onClick={() => {
                  setActiveGia(!activeGia);
                }}
              >
                Generate {activeGia ? "Manually" : "By GIA"}
              </p>
               <p
                onClick={() => {
                  setReadRarity(!readRarity);
                }}
              >
               How to read an FCRF Rarity Report?
              </p>
           
              
              {printReport?.printAccess && <p
              className="generate_print_report"
                onClick={() => {
                  setPrintActive(!printActive);
                }}
              >
              Print Report
              </p>}
              
            </div>
          </div>
        </Form>
      ) : (
        <>
          {steps >= 1 && <DiamondWeight activeGia={activeGia} setActiveGia={setActiveGia} {...props}  />}
          {steps >= 2 && <DiamondColor {...props} />}
          {steps >= 3 && <DiamondShape {...props} />}
          {steps >= 4 && <DiamondSaturation {...props} />}
          {steps >= 5 && <DiamondClarity {...props} />}
          {!activeGia && (steps > 5) && (
                <div className="rarity-process-wrapper process-btn-rarity" id="processBtn">
                 <div className="container">
                  <div className="rarity-process-content">
                  <Button
                    className="processBtn"
                    disabled={steps > 5 ? false : true}
                    onClick={() => handleSubmit("manual")}
                  >
                    {(isActive || loader) ? <Spinner animation="border" /> :<CharFadeText text="Generate" disabled={steps > 5 ? false : true} />}
                  </Button>
                </div>
              </div>
            </div>

          )}
          
        </>
      ))
      }
      <Modal show={readRarity} className="how-to-read-rarity-modal" onHide={() => setReadRarity(false)} size="lg" centered>
        <Modal.Header closeButton>  </Modal.Header>
        <iframe src={`https://www.fcresearch.org/how-to-read-an-fcrf-rarity-report/`}  height={"100%"}  
        width={"100%"}
        title="Fancy Color Diamond Diary"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        // allowFullScreen
        
        
        />
      </Modal>

    </div>

  );
};
export default GiaNumber;

const LeftArrowSVg=()=>{
  return(
    <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26.5 12H3.5" stroke="#D5B65A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 19L3 12L10 5" stroke="#D5B65A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

const LeftArrow = ()=>{
  return (
    <svg width="14" height="10" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.139032 2.89328C-0.0171776 3.04948 -0.0171776 3.30275 0.139032 3.45896L2.68462 6.00454C2.84083 6.16075 3.09409 6.16075 3.2503 6.00454C3.40651 5.84833 3.40651 5.59507 3.2503 5.43886L0.98756 3.17612L3.2503 0.913376C3.40651 0.757166 3.40651 0.5039 3.2503 0.34769C3.09409 0.191481 2.84083 0.191481 2.68462 0.34769L0.139032 2.89328ZM9.62012 2.77612L0.421875 2.77612L0.421875 3.57612L9.62012 3.57612L9.62012 2.77612Z" fill="#BF8F02"/>
</svg>

  )
}

const PrintIcon = () =>{
  return (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.3334 3.898V1.148H4.66669V3.898H3.70835V0.231335H13.2917V3.898H12.3334ZM13.8811 7.10633C14.1526 7.10633 14.3804 7.01833 14.5644 6.84233C14.7484 6.66633 14.84 6.44878 14.8394 6.18967C14.8388 5.93056 14.7471 5.7127 14.5644 5.53608C14.3816 5.35947 14.1539 5.27147 13.8811 5.27208C13.6083 5.2727 13.3808 5.3607 13.1987 5.53608C13.0166 5.71147 12.9246 5.92933 12.9227 6.18967C12.9208 6.45 13.0128 6.66756 13.1987 6.84233C13.3846 7.01711 13.6114 7.10511 13.8811 7.10633ZM12.3334 13.4167V9.25683H4.66669V13.4167H12.3334ZM13.2917 14.3333H3.70835V10.6667H0.427979V5.73133C0.427979 5.21189 0.612298 4.77647 0.980937 4.42508C1.34958 4.0737 1.80415 3.8977 2.34465 3.89708H14.6554C15.1985 3.89708 15.6537 4.07308 16.021 4.42508C16.3884 4.77708 16.5721 5.2122 16.5721 5.73042V10.6667H13.2917V14.3333ZM15.6137 9.75V5.73133C15.6137 5.47161 15.522 5.25375 15.3387 5.07775C15.1553 4.90175 14.9276 4.81375 14.6554 4.81375H2.34465C2.07312 4.81375 1.84567 4.90175 1.66231 5.07775C1.47895 5.25375 1.38695 5.47161 1.38631 5.73133V9.75H3.70835V8.34017H13.2917V9.75H15.6137Z" fill="white"/>
<path d="M1.38631 4.81467H15.6137M12.3334 3.898V1.148H4.66669V3.898H3.70835V0.231335H13.2917V3.898H12.3334ZM13.8811 7.10633C14.1526 7.10633 14.3804 7.01833 14.5644 6.84233C14.7484 6.66633 14.84 6.44878 14.8394 6.18967C14.8388 5.93056 14.7471 5.7127 14.5644 5.53608C14.3816 5.35947 14.1539 5.27147 13.8811 5.27208C13.6083 5.2727 13.3808 5.3607 13.1987 5.53608C13.0166 5.71147 12.9246 5.92933 12.9227 6.18967C12.9208 6.45 13.0128 6.66756 13.1987 6.84233C13.3846 7.01711 13.6114 7.10511 13.8811 7.10633ZM12.3334 13.4167V9.25683H4.66669V13.4167H12.3334ZM13.2917 14.3333H3.70835V10.6667H0.427979V5.73133C0.427979 5.21189 0.612298 4.77647 0.980937 4.42508C1.34958 4.0737 1.80415 3.8977 2.34465 3.89708H14.6554C15.1985 3.89708 15.6537 4.07308 16.021 4.42508C16.3884 4.77708 16.5721 5.2122 16.5721 5.73042V10.6667H13.2917V14.3333ZM15.6137 9.75V5.73133C15.6137 5.47161 15.522 5.25375 15.3387 5.07775C15.1553 4.90175 14.9276 4.81375 14.6554 4.81375H2.34465C2.07312 4.81375 1.84567 4.90175 1.66231 5.07775C1.47895 5.25375 1.38695 5.47161 1.38631 5.73133V9.75H3.70835V8.34017H13.2917V9.75H15.6137Z" stroke="white" stroke-width="0.1" fill="#BF8F02"/>
</svg>

  )
}
